<script setup lang="ts">
/**
 * UI-kit component
 * Category: Wrappers
 * Name: WrapperFilters
 */

defineOptions({
  name: 'WrapperFilters',
})
</script>

<template>
  <div class="wrapper-filters">
    <div class="wrapper-filters__fields">
      <slot />
    </div>
    <div
      v-if="$slots.controls"
      class="wrapper-filters__controls"
    >
      <slot name="controls" />
    </div>
  </div>
</template>

<style lang="scss" scoped src="../styles/_wrapper-filters.scss" />
